export type SchoolType
  = 'Escola Privada'
  | 'Escola Pública'
  | 'Universidade/Pós-graduação'
  | 'Curso de Idiomas'
  | 'Curso Técnico'
  | 'Curso Preparatório'
  | 'Curso Livre'
  | 'Outros';

export const schoolTypeOptions: SchoolType[] = [
  'Escola Privada',
  'Escola Pública',
  'Universidade/Pós-graduação',
  'Curso de Idiomas',
  'Curso Técnico',
  'Curso Preparatório',
  'Curso Livre',
  'Outros'
];
